import { render, staticRenderFns } from "./ManagePayBoxSidebar.vue?vue&type=template&id=f3c88816&"
import script from "./ManagePayBoxSidebar.vue?vue&type=script&lang=js&"
export * from "./ManagePayBoxSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3c88816')) {
      api.createRecord('f3c88816', component.options)
    } else {
      api.reload('f3c88816', component.options)
    }
    module.hot.accept("./ManagePayBoxSidebar.vue?vue&type=template&id=f3c88816&", function () {
      api.rerender('f3c88816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/manage-pay-box/ManagePayBoxSidebar.vue"
export default component.exports